/* eslint-disable react-hooks/exhaustive-deps */
import { InputDate } from "@grapecity/wijmo.react.input"
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjcInput from "@grapecity/wijmo.input"
import React, { useEffect, useRef, useState } from "react"

import dayjs from "dayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretLeft, faCaretRight } from "@fortawesome/free-solid-svg-icons"
import dateUtil from "../../ts/util/dateUtil"
import { useSelector } from "react-redux"
import { RootState } from "../../globalStore/rootreducer"

const DateInput: React.FC<{
  className?: string
  autoFocus?: boolean
  defaultValue?: string | null
  value: string | null | undefined
  setValue: (value: string | null | undefined) => unknown
  id?: string
  format?: string
  showDropDownButton?: boolean
  isRequired?: boolean
  isReadOnly?: boolean
  placeholder?: string
  isDisabled?: boolean
  min?: string
  max?: string
  has1DayButton?: boolean
  itemFormatter?: wjcInput.IDateFormatter
  showHoliday?: boolean
}> = ({
  className,
  autoFocus,
  defaultValue,
  setValue,
  value,
  showDropDownButton,
  id,
  format = "d",
  isRequired = false,
  isReadOnly,
  placeholder,
  isDisabled,
  min,
  max,
  has1DayButton,
  itemFormatter,
  showHoliday,
}) => {
  const target = useRef(null)
  const defaultDateValue =
    defaultValue != null
      ? dayjs(defaultValue).isValid()
        ? dayjs(defaultValue).toDate()
        : undefined
      : null

  const [dateValue, setDateValue] = useState<Date | null | undefined>(
    defaultDateValue
  )
  const [inputDate, setInputDate] = useState<wjcInput.InputDate>()
  const [classNameInner, setClassNameInner] = useState("")
  const 休日List = useSelector((state: RootState) => state.date.休日List)

  const checkInvalidValue = (
    s: wjcInput.InputDate,
    e: wjcCore.CancelEventArgs
  ) => {
    let tmp = s.text.replace(/T.[0-9]:.[0-9]:.[0-9]/g, "")
    let str = tmp.replace(/-/g, "")
    if (str.match("[0-9]{8}")) {
      let y = str.substring(0, 4)
      let m = str.substring(4, 6)
      let d = str.substring(6, 8)
      let dayStr = y + "-" + m + "-" + d
      let inputDay = dayjs(dayStr).format("YYYY/MM/DD")
      s.text = inputDay
      e.cancel = false
    }
  }

  const addDate = (orPlusMinus: string) => {
    let addDate = value ?? ""
    if (orPlusMinus === "plus") {
      addDate = dayjs(addDate).add(1, "day").toString()
    } else {
      addDate = dayjs(addDate).add(-1, "day").toString()
    }
    setDateValue(dayjs(addDate).toDate())
  }

  const coloredHoliday: wjcCore.IEventHandler<
    wjcInput.Calendar,
    wjcInput.FormatItemEventArgs
  > = dateUtil.inputDateOffDayFormatHandler(showHoliday ? 休日List : [])

  // placeHolderとfloatinglabel用
  const [innerText, setInnerText] = useState<string>()
  const [isShowFloatingLabel, setIsShowFloatingLabel] = useState<boolean>()

  // valueの上書きがループしないよう制御
  const [isValueChanged, setIsValueChanged] = useState(false)

  useEffect(() => {
    if (
      placeholder &&
      innerText != null &&
      innerText !== "" &&
      value != null &&
      value !== ""
    ) {
      setIsShowFloatingLabel(true)
    } else {
      setIsShowFloatingLabel(false)
    }
  }, [innerText, placeholder, value])

  useEffect(() => {
    // valueChangedが走り終わった後に処理する
    if (!isValueChanged && value == null) return

    // valueをcomponent内のstateにセット
    if (value != null && dayjs(value).isValid()) {
      setDateValue(dayjs(value).toDate())
    } else {
      setDateValue(null)
    }
    setIsValueChanged(false)
  }, [value])

  // classあて
  useEffect(() => {
    const classNameArray: string[] = []
    isRequired && classNameArray.push("required_input")
    className && classNameArray.push(className)
    if (classNameArray.length > 0) {
      setClassNameInner(classNameArray.join(" "))
    } else {
      setClassNameInner("")
    }
  }, [isRequired, className])

  useEffect(() => {
    if (inputDate) {
      inputDate.calendar.formatItem.removeAllHandlers()
      inputDate.calendar.formatItem.addHandler(coloredHoliday)
    }
  }, [休日List, inputDate, showHoliday])

  return (
    <div ref={target} className="floating-frame">
      {isShowFloatingLabel && (
        <span className="floating-label">{placeholder}</span>
      )}
      <ul className="list-cmn list-cmn-inline d-flex">
        {has1DayButton && (
          <li>
            <button
              type="button"
              className="icon-button"
              onClick={(e) => addDate("minus")}>
              <FontAwesomeIcon
                className="icon-button-inner"
                icon={faCaretLeft}></FontAwesomeIcon>
            </button>
          </li>
        )}
        <li>
          <InputDate
            id={id}
            format={format}
            className={classNameInner}
            isRequired={isRequired}
            isReadOnly={isReadOnly}
            defaultValue={defaultDateValue}
            showDropDownButton={showDropDownButton}
            itemFormatter={itemFormatter}
            value={dateValue}
            setValue={setDateValue}
            placeholder={isShowFloatingLabel ? "" : placeholder ?? ""}
            isDisabled={isDisabled}
            invalidInput={checkInvalidValue}
            min={min ? dayjs(min).toDate() : null}
            max={max ? dayjs(max).toDate() : null}
            valueChanged={(s: wjcInput.InputDate, e: wjcCore.EventArgs) => {
              if (isRequired && !wjcCore.isDate(s.value)) {
                wjcCore.toggleClass(s.hostElement, "is-error", true)
              } else {
                wjcCore.toggleClass(s.hostElement, "is-error", false)

                if (s.value && dayjs(s.value).isValid()) {
                  setValue(dayjs(s.value).toISOString())
                } else {
                  setValue(null)
                }
                setIsValueChanged(true)
              }
            }}
            textChanged={(control: wjcInput.InputDate) => {
              setInnerText(control.text)
            }}
            initialized={(control: wjcInput.InputDate) => {
              if (autoFocus) control.inputElement?.focus()
              setInputDate(control)
            }}
          />
        </li>

        {has1DayButton && (
          <li>
            <button
              type="button"
              className="icon-button"
              onClick={(e) => addDate("plus")}>
              <FontAwesomeIcon
                className="icon-button-inner"
                icon={faCaretRight}></FontAwesomeIcon>
            </button>
          </li>
        )}
      </ul>
    </div>
  )
}

export default DateInput
